<template>
    <TableProjectOperationByJob></TableProjectOperationByJob>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TableProjectOperationByJob = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/OperationByJob/Table.vue")
);

export default {
    name: "Project_Management_Sheet_Inv",
    components: { TableProjectOperationByJob, AuthLayout },
};
</script>
